import { RETURN_TO_PARAM, sanitizeReturnTo } from './returnTo';

const APP_ORIGIN = 'https://app.local';

// Carry a destination through onboarding without allowing a registration URL
// to select a role or recursively wrap another registration URL.
export const readRegistrationReturnTo = (search: string): string | null => {
  const returnTo = sanitizeReturnTo(new URLSearchParams(search).get(RETURN_TO_PARAM), APP_ORIGIN);
  return returnTo && !returnTo.startsWith('/register/') ? returnTo : null;
};

export const buildRegistrationPath = (path: string, returnTo?: string | null): string => {
  const target = sanitizeReturnTo(returnTo, APP_ORIGIN);
  if (!target || target.startsWith('/register/')) return path;

  return `${path}?${new URLSearchParams({ [RETURN_TO_PARAM]: target }).toString()}`;
};
